var map = {
	"./add.svg": 95869,
	"./alipay.svg": 83546,
	"./arrdown.svg": 53753,
	"./arrleft.svg": 69058,
	"./arrup.svg": 34998,
	"./article-create.svg": 72531,
	"./article-ranking.svg": 38143,
	"./article.svg": 66586,
	"./audit.svg": 79537,
	"./bankcard.svg": 63888,
	"./bankcard1.svg": 26673,
	"./base-data.svg": 51820,
	"./bell.svg": 45292,
	"./binding.svg": 1831,
	"./blocked.svg": 6292,
	"./brandshop.svg": 40111,
	"./cart-down.svg": 63423,
	"./change-theme.svg": 4052,
	"./chart.svg": 38972,
	"./client-skin.svg": 20477,
	"./close.svg": 37832,
	"./cloth.svg": 69328,
	"./cloth1.svg": 6705,
	"./colapse.svg": 53313,
	"./collapse.svg": 33785,
	"./copy.svg": 33939,
	"./dashboard.svg": 93512,
	"./data-upload.svg": 62738,
	"./delete.svg": 16717,
	"./diagnosis.svg": 26739,
	"./disabled.svg": 98876,
	"./disdroy.svg": 52470,
	"./down.svg": 61152,
	"./download.svg": 97628,
	"./download2.svg": 9510,
	"./edit.svg": 87024,
	"./empty.svg": 57999,
	"./error.svg": 50046,
	"./example.svg": 64006,
	"./exit-fullscreen.svg": 77078,
	"./expand.svg": 17620,
	"./expaned.svg": 11347,
	"./eye-open.svg": 40340,
	"./eye.svg": 90443,
	"./financial.svg": 3505,
	"./fullscreen.svg": 59191,
	"./getback.svg": 70921,
	"./gouxuan.svg": 88283,
	"./group.svg": 1461,
	"./guide.svg": 48404,
	"./hamburger-closed.svg": 35682,
	"./hamburger-opened.svg": 67678,
	"./histoires.svg": 81518,
	"./image.svg": 32187,
	"./info.svg": 36424,
	"./international.svg": 86344,
	"./introduce.svg": 60891,
	"./inventory.svg": 34304,
	"./language.svg": 25082,
	"./link.svg": 83684,
	"./loading.svg": 79056,
	"./medtruansfer.svg": 81230,
	"./myreg.svg": 19156,
	"./nested.svg": 68517,
	"./new.svg": 19694,
	"./next.svg": 6823,
	"./outlinepay.svg": 77220,
	"./outorder.svg": 19536,
	"./package.svg": 92108,
	"./password.svg": 64815,
	"./permission.svg": 52297,
	"./personnel-info.svg": 19605,
	"./personnel-manage.svg": 45668,
	"./personnel.svg": 77516,
	"./prev.svg": 89019,
	"./refresh.svg": 85037,
	"./require.svg": 74409,
	"./reward.svg": 833,
	"./role.svg": 35708,
	"./save.svg": 21867,
	"./search.svg": 38472,
	"./setting.svg": 85616,
	"./setting1.svg": 81425,
	"./shared.svg": 96747,
	"./shift.svg": 78560,
	"./size.svg": 2791,
	"./size1.svg": 48724,
	"./success.svg": 85581,
	"./table.svg": 41224,
	"./tel.svg": 37891,
	"./tree.svg": 91460,
	"./up.svg": 8403,
	"./upload.svg": 68335,
	"./user.svg": 64421,
	"./video.svg": 51229,
	"./viewer.svg": 84186,
	"./warn.svg": 71776,
	"./wechat.svg": 56206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;